export default __webpack_public_path__ + "static/media/_DSC0559.e3567804.JPG";